const initVideoPlays = (buttons) => {
    buttons.forEach((button) => {
        const video = button.parentNode.querySelector('video');
        video.autoplay = false;
        video.controls = false;
        video.pause();

        button.addEventListener('click', () => {
            button.classList.add('interacted');
            video.play();
            video.controls = true;
        });
    });
};

export default initVideoPlays;
